import React from "react";
import img1 from "../pages/image1/IMG-20240919-WA0011.jpg";
import img2 from "../pages/image1/IMG-20240928-WA0023.jpg";
import img3 from "../pages/image1/IMG-20240928-WA0024.jpg";
import './destination.css'
import '../pages/ProductDetail.css'
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel'; 
import Typography from '@mui/material/Typography';
import SimpleImageSlider from "react-simple-image-slider";
import Swipernew from "./Swipernew";
import slide_image_1 from '../pages/image1/IMG-20240928-WA0018.jpg';
import slide_image_2 from '../pages/image1/IMG-20240928-WA0014.jpg';
import slide_image_3 from '../pages/image1/IMG-20240928-WA0023.jpg';
import slide_image_4 from '../pages/image1/IMG-20240928-WA0012.jpg';



export default function Destination1() {

 const imageArray = [
  slide_image_1,
  slide_image_2,
  slide_image_3,
  slide_image_4,

];
  return (
    <>
    <div>
 
<div>
            <Swipernew images={imageArray} />
        </div>



      <div className="m-2 pt-5">
        <div className="container-fluid">
        <div className="ms-auto me-auto  bg2">

          <h1 className="text-center name11  ">
            5-Day Gorillas, Chimpanzees, and Wildlife Safari in Uganda
          </h1>
        </div>

          <h2>Description:</h2>
          <h3 className="ms-3 pt-3">
            &emsp;&emsp;This 5 Days classic tour will take you to some of the Uganda’s
            best National parks
          </h3>
        </div>

        <div className="container-fluid">
        <Box sx={{ padding: 2 }}>
      <Stepper orientation="vertical" activeStep={5}>
        {steps.map((step, index) => (
          <Step key={step.label1} color="black">
            {/* Pass label1 to StepLabel */}

            <StepLabel><h3> {step.label1}</h3></StepLabel>
            <div className=" bordernew  ">
            {/* Add the secondary label (optional, shown below the main one) */}
            <Typography variant="subtitle1" color="textblack" sx={{ ml: 2 }}>
              <h4><b>{step.label}</b></h4>
            </Typography>
            {/* Directly display the description */}
            <Typography sx={{ mt: 1, mb: 2, ml: 2 }}><h4>&emsp;{step.description}</h4></Typography></div>
          </Step>
        ))}
      </Stepper>
    </Box>
         

         

          

        
        </div>
      </div>
      <div class="btn-box text-white text-center">
                        <a href="https://wa.me/+971551579904" class="theme-btn btn-style-one rounded-3 m-4 ">Book Now</a>
                    </div>

    


</div>
    </>
  );
}


const steps = [
  {
    label1: 'Day - 1',
    label: 'Pick Up and Transfer to Queen Elizabeth National Park',
    description: ` Our company driver /guide will pick you up from Entebbe International Airport or your Hotel and depart for Queen Elizabeth National Park. You will have lunch en-route. Making this trip by road has always been one of the best decisions as you will have the chance to explore and look at the Uganda’s beautiful sceneries. From African villages with green covered hills to tea plantations, banana plantations and many others. You will arrive at the lodge late in the evening. You may do an evening game drive if time allows otherwise take a rest till the next day.`,
  },
  {
    label1: 'Day - 2',
    label: 'Chimpanzees Trekking and Afternoon Boat Cruise',
    description:
      'You will be treated to fresh early morning breakfast before you proceed for Chimpanzees trekking in Kalinzu forest, The rangers will brief you about the trip and general information then embark on the forest hike, here you will have a chance to see chimpanzees in their natural habitat. In the afternoon hours, you will partake in a launch cruise along the Kazinga Channel. You will be able to see high scores of elephants, hippos, buffalos, and crocodiles and a number of bird species including the rare shoe bill.',
  },
  {
    label1: 'Day - 3',
    label: 'Tree-Climbing Lions in Ishasha and Transfer to Bwindi for Gorilla Trekking.',
    description: `On this day, you will be transferred to Bwindi Impenetrable National Park through Ishasha, a sector of Queen Elizabeth National Park where you will have a chance to see the tree climbing lions.<br> In Ishasha, we will drive off in this adventurous vast savannah area with topis and African elephants and you will hopefully get the lions high in the fig tree branches. You will have lunch in Ishasha and continue with the transfer to Bwindi Impenetrable National Park. Experience the beautiful sceneries in the landscape from flat savanna, via cultivated hills to very green jungle covered mountains.`
  },
  {
    label1: 'Day - 4',
    label: ' Gorilla Tracking and Transfer to Lake Mburo National Park',
               
    description: `Wake up to an early morning breakfast and proceed to the briefing point. Enjoy the highlight of your trip—gorilla trekking. The trekking may last from 2 to 6 hours depending on the group you are visiting. Expect to trek through the rainforest and bamboo covered slopes, accompanied by a Uganda Wildlife Authority guide and other trackers, in search of a mountain gorilla family. The walking can sometimes be tough and long but worthwhile most especially when you catch a glimpse of this magnificent animals in their natural habitat. Due to the nature of the activity, you will have packed lunch. After gorilla trekking, embark on your journey to Lake Mburo National Park.`
  },
  {
    label1: 'Day - 5',
    label: '  Early Morning Game Drive in Lake Mburo National Park and Transfer to Entebbe',
               
    description: `After having an early breakfast, go for a morning game drive in Lake Mburo National Park. This park is famous for zebras, impalas, giraffes, elands, Cape buffalos and many tropical bird species. Checkout of the park and transfer to Entebbe with lunch en-route.

On your way, you will make a stopover at the Equator line to have a real time experience of Latitude 0 degrees where you will stand with your one leg on the southern hemisphere and the other on the Northern hemisphere. From there, you will proceed to Kampala or Entebbe and to be dropped off at your point of call.`,
  },
];


